export default bounds => {
  if (!bounds) return null
  const [swLat, swLng, neLat, neLng] = bounds.map(parseFloat)
  return {
      lat: (swLat + neLat) / 2,
      lng: (swLng + neLng) / 2
  }
}



// WEBPACK FOOTER //
// ./src/schemas/migrator/helpers/locationFromBounds.js